export const hexToRgba = (hex: string, alpha: string): string => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  const r = result ? parseInt(result[1], 16) : 0
  const g = result ? parseInt(result[2], 16) : 0
  const b = result ? parseInt(result[3], 16) : 0
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export const sortByEmployeeJobNo = (a: any, b: any) => {
  return a?.jobNo < b?.jobNo
    ? -1
    : a?.jobNo > b?.jobNo
    ? 1
    : 0;
};